/* Cycles product card photos for cards marked data-card-rotate.
   Rotates only while the card is on screen, pauses on hover/focus, and stays
   on the first photo for visitors who prefer reduced motion. */
(function () {
  var INTERVAL_MS = 2500;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function setup(container) {
    if (container.dataset.cardRotateBound) return;
    var slides = Array.prototype.slice.call(container.querySelectorAll(':scope > img'));
    if (slides.length < 2) return;
    container.dataset.cardRotateBound = 'true';

    var index = 0;
    var timer = null;
    var paused = false;
    slides[0].classList.add('is-active');
    container.classList.add('card-rotate--ready');

    function show(next) {
      slides[index].classList.remove('is-active');
      index = next % slides.length;
      var img = slides[index];
      if (img.loading === 'lazy') img.loading = 'eager';
      img.classList.add('is-active');
    }
    function start() {
      if (timer || paused) return;
      // warm the next photo so the first fade is smooth
      if (slides[1].loading === 'lazy') slides[1].loading = 'eager';
      timer = setInterval(function () { show(index + 1); }, INTERVAL_MS);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }

    var card = container.closest('.card-wrapper') || container;
    card.addEventListener('mouseenter', function () { paused = true; stop(); });
    card.addEventListener('mouseleave', function () { paused = false; start(); });
    card.addEventListener('focusin', function () { paused = true; stop(); });
    card.addEventListener('focusout', function () { paused = false; start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.isIntersecting ? start() : stop(); });
      }, { threshold: 0.3 }).observe(container);
    } else {
      start();
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-card-rotate]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  // collection filtering / infinite scroll / recommendations inject cards later
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
